<script>

export default {
    name: "RangeSlider",
    props: {
        value: {
            type: Number,
            default: 0
        },
        max: {
            type: Number,
            default: 0
        }
    },
    emits: ["input"],
    data() {
        return {
            nowFrame: this.value
        }
    },
    watch: {
        value(val) {
            this.nowFrame = val
        }
    },
    mounted() {
        // $('#range').rangeslider()
    },
    methods: {
        rangeInput(e) {
            this.$emit("input", e.target.value)
        }
    }
}
</script>

<template>
    <input
        id="range"
        v-model.number="nowFrame"
        type="range"
        :min="0"
        :max="max"
        :step="1"
        data-orientation="vertical"
        @input="rangeInput"
    >
</template>

<style scoped>

[type="range"] {
    display: block;
    position: relative;
    width: 320px;
    top: 25px;
    margin: 0 auto;
    height: 5px;
    background-color: rgba(51, 51, 51, 0.95);
}

[type="range"]::-webkit-slider-thumb {
    -webkit-appearance: none;
    position: relative;
    z-index: 15;
    width: 25px;
    height: 25px;
    background-color: rgba(173, 173, 173, 0.3);
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    border-radius: 50%;
    cursor: pointer;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
}

[type="range"]:focus,
[type="range"]:focus::-webkit-slider-thumb,
[type="range"]:active,
[type="range"]:active::-webkit-slider-thumb {
    cursor: pointer;
    outline: none;
}

[type="range"]:active::-webkit-slider-thumb {
    background-color: rgba(255, 20, 147, 1.0);
}
</style>
